import styled from 'styled-components';

import { useAdAccountContext } from '../../contexts/AdAccountContext';
import { CheckboxField } from './CheckBoxField';
import { AdAccountDivider } from './AdAccountDivider';

const GroupedContainer = styled.div`
  display: flex;
  width: ${({ theme }) => theme.spacing.utils.pxToRem(500)};
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing.values.base};
`;

const StyledAdAccountForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  height: ${({ theme }) => theme.spacing.values.x24};
  margin: 0 20px;
  overflow: overlay;
`;

export const SelectAdAccountForm = () => {
  const { adAccountIds, unselectedAdAccountIds, isLoading } = useAdAccountContext();
  const isDividerHidden = unselectedAdAccountIds.length === 0 || adAccountIds.length === 0;

  if (isLoading) return null;

  return (
    <StyledAdAccountForm data-test="select-ad-account-form">
      <GroupedContainer>
        {adAccountIds.map((adAccountId, index) => (
          <CheckboxField key={`selected-${index}-${adAccountId}`} adAccountId={adAccountId} />
        ))}
      </GroupedContainer>
      {!isDividerHidden && <AdAccountDivider />}
      <GroupedContainer data-test="group-container">
        {unselectedAdAccountIds.map((adAccountId, index) => (
          <CheckboxField key={`unselected-${index}-${adAccountId}`} adAccountId={adAccountId} />
        ))}
      </GroupedContainer>
    </StyledAdAccountForm>
  );
};
